import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import Home from '@/views/Home'
import About from '@/views/About'
import Exhibition from '@/views/Exhibition'
import Exhibitions from '@/views/Exhibitions'
import Publications from '@/views/Publications'

Vue.use(Router)
Vue.use(Meta)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/publications',
      name: 'publications',
      component: Publications
    },
    {
      path: '/exhibitions',
      name: 'exhibitions',
      component: Exhibitions
    },
    {
      path: '/exhibitions/:uid',
      name: 'exhibition',
      component: Exhibition,
      props: true
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})
